// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App";
import axios from "axios"; //引入文件
import store from "./store";
import router from "./router";
import "element-ui/lib/theme-chalk/index.css";
import "@/common/common.css"; //公共样式
import VueAMap from "vue-amap";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import customParseFormat from "dayjs/plugin/customParseFormat";
import preview from "vue-photo-preview";
import "vue-photo-preview/dist/skin.css";
import echarts from "../src/utils/echarts";
import SjAndYuny from "./components/sjandyuny.vue";
import globalfunc from "./utils/globalfunc"; //全局函数
import { getCachedOssSignature } from "./utils/ossSignatureCache";

let moment = require("moment");
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.$globalfunc = globalfunc;
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
Vue.prototype.dayjs = dayjs;
Vue.use(preview);
Vue.use(VueAMap);
Vue.use(ElementUI, { size: "mini" });
Vue.component(SjAndYuny.name, SjAndYuny);
VueAMap.initAMapApiLoader({
  // key: "6b5bd7de16456cbc5d7d117502e4bb7f", // 许海强的152
  // key: "7a1b7a869e0bf3cb9d98a52db5e97941", // 许海强的156
  // key: "7f0fe1fd6a8d955527148b7c1ff9019e", // 企业key
  // key: "8bcdc29a8b2e1a017490fbd7c704a128", // 苏振龙的
  // key: "3a5f7edfb69f8e4b1ca9c49dc88b77ed", // 张宁宁的
  // key: "b933850144f82fb95eea5e69c9e550b1", // 王向阳的
  // key: "e1833ddaed11f727cbe2bfdefd55f90a", //盛成伟的
// key: "ebabdb3c485f6c5c7cef8b977d803bbb", //赵宇航的
  key: "556ceadf21439a2a025eec2d11027aed", //金昕涛的
  // securityJsCode: '26aae1482d4391f62dbcc8699ca27e3a', // 加在这里不管用，加在app.vue里面了
  plugin: [
    "AMap.Autocomplete", //输入提示插件
    "AMap.PlaceSearch", //POI搜索插件
    "AMap.Scale", //右下角缩略图插件 比例尺
    "AMap.OverView", //地图鹰眼插件
    "AMap.ToolBar", //地图工具条
    "AMap.MapType", //类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
    "AMap.PolyEditor", //编辑 折线多，边形
    "AMap.CircleEditor", //圆形编辑器插件
    "AMap.Geolocation", //定位控件，用来获取和展示用户主机所在的经纬度位置
    "AMap.Driving",
    "AMap.Transfer",
    "AMap.Walking",
    "AMap.Riding",
    "AMap.Geocoder",
    "AMap.Heatmap",
    "AMap.MassMarks",
    "AMap.DistrictSearch",
  ],
});
Vue.directive("preventReClick", {
  //自定义防抖指令
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 3000);
      }
    });
  },
});

axios.defaults.timeout = 200000;
axios.interceptors.request.use((config) => {
  const url = String((config && config.url) || "");
  const isOssHost =
    /aliyuncs\.com/i.test(url) || /cdn\.xaoji\.com/i.test(url);
  // OSS/CDN 直传不要带 ERP Authorization，避免多余预检，也避免干扰签名
  if (!isOssHost) {
    let token = sessionStorage.getItem("Authorization");
    let zukeToken = sessionStorage.getItem("zukeToken");
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (zukeToken && url.includes("/xiaojizuke/")) {
      // 小鸡租客的 token
      config.headers["token"] = zukeToken;
    }
  }
  return config;
});
axios.interceptors.response.use(
  (res) => {
    if (res.data.msg == "身份验证失败") {
      if (Vue.prototype.$myLoading) {
        Vue.prototype.$myLoading.close();
      }
      router.push({
        path: "/login",
      });
    }
    return res;
  },
  (error) => {
    let { config, response } = error;
    if (!response) {
      return Promise.reject(error);
    }
    let status = response.status;
    if (status === 401 || status === 403) {
      return axios
        .get("https://www.xaoji.com/xiaojizuke/member/login/isUser", {
          params: {
            code: "Ra7Z5cmbyxzzYaM",
          },
        })
        .then((data) => {
          sessionStorage.setItem("zukeToken", data.data.data);
          return axios(config);
        })
        .catch((loginError) => {
          console.error(loginError);
          return Promise.reject(loginError);
        });
    }
    console.error(response.data);
    return Promise.reject(response.data);
  }
);

function getMapCenter() {
  let city = store.state.Counter.city;
  let center = [];
  if (city === "苏州") {
    center = [120.619585, 31.299379];
  } else if (city === "天津") {
    center = [117.201538, 39.085294];
  } else if (city === "绍兴") {
    center = [120.582886, 30.051549];
  } else if (city === "宁波") {
    center = [121.6216, 29.859515];
  } else {
    center = [120.051238, 30.228232];
  }
  return center;
}

function SortFun(attr, rev) {
  //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
  if (rev == undefined) {
    rev = 1;
  } else {
    rev = rev ? 1 : -1;
    //rev = rev>0 ? 1 : -1;
  }
  return function (a, b) {
    a = a[attr] ? a[attr] : "0";
    b = b[attr] ? b[attr] : "0";
    if (a !== null) {
      // 1.列数据类型为string时的排序
      if (typeof a == "string") {
        // 1.1 判断是否为日期类型
        if (a.split("-").length === 3) {
          if (a < b) {
            return rev * -1;
          }
          if (a > b) {
            return rev * 1;
          }
          return 0;
        } else if (!isNaN(a)) {
          // 是否能转为数字类型
          console.log("字符数字类型", attr, a);
          if (parseFloat(a) < parseFloat(b)) {
            return rev * -1;
          }
          if (a > b) {
            return rev * 1;
          }
          return 0;
        } else {
          // 1.2 普通字符类型
          console.log("普通字符类型", attr, a);
          if (a < b) {
            return rev * -1;
          }
          if (a > b) {
            return rev * 1;
          }
          return 0;
        }
      }
      // 2. 列数据类型为number时的排序
      if (typeof a == "number") {
        console.log("Number型:", a);
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      }
    }
  };
}
//生成一个随机id
function createId(time) {
  time = time || Date.now();
  return Number(Math.random().toString().slice(3, 6) + time).toString(36);
}

// 上传图片
// option.keys ['file','head_name','limit_size','full_name','fileType']
// return image's url
async function uploadImage(option = {}) {
  // 格式化尺寸
  function formatSize(size) {
    if (size < 1000 * 1000) {
      return (size / 1000).toFixed(1) + "Kb";
    } else {
      return (size / (1000 * 1000)).toFixed(1) + "Mb";
    }
  }

  //压缩图片
  function compress() {
    return new Promise(function (resolve, reject) {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      let img = new Image();
      reader.onload = function (e) {
        let canvas = document.createElement("canvas");
        let drawer = canvas.getContext("2d");
        img.src = this.result;
        img.onload = function () {
          let width = img.width;
          let height = img.height;
          let quality = 0.85;
          canvas.height = height;
          canvas.width = width;
          let judge = true;
          if (width > height) {
            if (height > 1080) {
              judge = false;
              canvas.height = 1080;
              canvas.width = parseInt((width / height) * 1080);
            }
          } else {
            if (width > 1080) {
              judge = false;
              canvas.width = 1080;
              canvas.height = parseInt((height / width) * 1080);
            }
          }
          if (judge) {
            quality = 5;
          }
          console.log("画布宽高", canvas.width, canvas.height);
          drawer.drawImage(img, 0, 0, canvas.width, canvas.height);
          let afterCanvas = canvas.toDataURL("image/jpeg", quality);
          resolve(dataURItoBlob(afterCanvas));
        };
      };
    });
  }

  //格式转换
  function dataURItoBlob(base64Data) {
    let byteString;
    if (base64Data.split(",")[0].indexOf("base64") >= 0) {
      byteString = atob(base64Data.split(",")[1]);
    } else {
      byteString = unescape(base64Data.split(",")[1]);
    }
    let mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
    let ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], {
      type: mimeString,
    });
  }

  function isOssSignatureUploadError(err) {
    let status =
      (err && err.response && err.response.status) || (err && err.status);
    if (status === 400 || status === 403) {
      return true;
    }
    let message = "";
    if (typeof err === "string") {
      message = err;
    } else if (err) {
      message = [
        err.Code,
        err.code,
        err.Message,
        err.message,
      ].filter(Boolean).join(" ");
      try {
        message += " " + JSON.stringify(err);
      } catch (jsonError) {}
    }
    return /AccessDenied|Signature|Policy|Expired|expire|invalid access key/i.test(message);
  }

  // 优先：显式 file_ext → 原文件名扩展名 → MIME 映射；复合 MIME 不能直接取 subtype
  function resolveUploadExt(upload_file, fallbackType, explicitExt) {
    const forced = String(explicitExt || "")
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
    if (forced && forced.length <= 8) return forced;

    const rawName = (upload_file && upload_file.name) || "";
    const fromName = rawName.includes(".")
      ? String(rawName.split(".").pop() || "")
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "")
      : "";
    if (fromName && fromName.length <= 8) return fromName;

    const mime = (upload_file && upload_file.type) || "";
    const mimeMap = {
      "application/pdf": "pdf",
      "application/msword": "doc",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
      "application/vnd.ms-powerpoint": "ppt",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        "pptx",
      "application/vnd.ms-excel": "xls",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "xlsx",
      "image/jpeg": "jpg",
      "image/jpg": "jpg",
      "image/png": "png",
      "image/gif": "gif",
      "video/mp4": "mp4",
    };
    if (mimeMap[mime]) return mimeMap[mime];

    const subtype = mime.split("/")[1] || "";
    if (subtype && subtype.indexOf(".") < 0 && subtype.indexOf("+") < 0) {
      return subtype === "jpeg" ? "jpg" : subtype;
    }
    return fallbackType || "bin";
  }

  //图片上传数据库
  async function upload(upload_file) {
    console.log("upload_file", upload_file);
    let bx = resolveUploadExt(upload_file, fileType, file_ext);
    let name = "." + bx;
    if (full_name) {
      name = full_name + name;
    } else {
      name = head_name + "_" + createId() + name;
    }
    let key = "img/" + name;
    if (fileType === "pdf") {
      key = "pdf/" + name;
    } else if (fileType === "video") {
      key = "video/" + name;
    } else if (fileType === "dae") {
      key = "dae/normal/" + name;
    } else if (fileType === "glb") {
      key = "glb/normal/" + name;
    } else if (fileType === "json") {
      key = "json/" + name;
    }
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    // 视频体积大：拉长超时，并允许展示进度；FormData 交给浏览器自动带 boundary
    if (fileType === "video") {
      config.timeout = 15 * 60 * 1000;
      delete config.headers["Content-Type"];
    }
    if (typeof option.onUploadProgress === "function") {
      config.onUploadProgress = option.onUploadProgress;
    }
    let urlMap = {
      杭州: "https://xiaoji-hangzhou.oss-cn-hangzhou.aliyuncs.com",
      苏州: "https://xiaoji-suzhou.oss-cn-hangzhou.aliyuncs.com",
      天津: "https://xiaoji-tianjin.oss-cn-beijing.aliyuncs.com",
      宁波: "https://xiaoji-ningbo.oss-cn-hangzhou.aliyuncs.com",
      上海: "https://xiaoji-shanghai.oss-cn-shanghai.aliyuncs.com",
    };
    var uploadUrl = urlMap[store.state.Counter.city];
    if (fileType === "dae" || fileType === "glb") {
      const urlMap3d = {
        杭州: "https://xjxf-3dmodel.oss-cn-hangzhou.aliyuncs.com",
        上海: "https://xjxf-3dmodel-sh.oss-cn-shanghai.aliyuncs.com",
      };
      uploadUrl = urlMap3d[store.state.Counter.city];
    }
    let cdnUrlMap = {
      杭州: "http://cdn.xaoji.com"
    }
    let signatureUrl = Vue.prototype.$url_prefix + "getOssSignature";
    async function getUploadAccess(forceRefresh) {
      try {
        return await getCachedOssSignature(
          signatureUrl,
          async function () {
            let res = await axios.get(signatureUrl);
            return res && res.data && res.data.data;
          },
          { forceRefresh: forceRefresh }
        );
      } catch (err) {
        console.log("access error", err);
      }
      return null;
    }
    function buildUploadFormData(access) {
      let param = new FormData();
      param.append("key", key);
      param.append("OSSAccessKeyId", access.OSSAccessKeyId);
      param.append("policy", access.policy);
      param.append("Signature", access.signature);
      param.append("file", upload_file);
      return param;
    }
    function postToOss(access) {
      return axios.post(uploadUrl, buildUploadFormData(access), config);
    }

    let access = await getUploadAccess(false);
    if (!access) {
      return false;
    }
    let resData;
    try {
      resData = await postToOss(access);
    } catch (err) {
      console.log("upload error", err);
      if (isOssSignatureUploadError(err)) {
        access = await getUploadAccess(true);
        if (!access) {
          return false;
        }
        try {
          resData = await postToOss(access);
        } catch (retryErr) {
          console.log("upload retry error", retryErr);
        }
      }
    }
    if (resData && resData.status === 204) {
      let finalUrl = cdnUrlMap[store.state.Counter.city] || uploadUrl;
      if (fileType === "pdf" || head_name === "djtd") {
        finalUrl = uploadUrl;
      }
      return finalUrl + "/" + key;
    }
    return false;
  }

  let file = option.file;
  let head_name = option.head_name;
  let full_name = option.full_name;
  let file_ext = option.file_ext || option.ext || "";
  let limit_size = option.limit_size || 500 * 1024; // 默认限制500k
  if (option.dataURL) {
    file = dataURItoBlob(option.dataURL);
    limit_size = "no";
  }
  if (!file || (!head_name && !full_name)) {
    console.log("wrong param");
    return false;
  }
  const accept = "image/gif, image/jpeg, image/png, image/jpg";
  let fileType = option.fileType || "image";
  if (fileType === "image" && (!file.type || !accept.includes(file.type))) {
    alert("图片格式不正确");
    return false;
  }
  console.log("filesize", formatSize(file.size));
  console.log("option.dataURL", store.state.Counter.city);

  if (fileType !== "image") {
    let limit = 500;
    if (file.type.includes("video")) {
      limit = 600000;
    } else if (fileType === "dae") {
      limit = 30000;
    } else if (fileType === "glb") {
      limit = 30000;
    } else if (fileType === "pdf") {
      limit = 30000;
    }
    if (file.size / 1000 > limit) {
      console.log("文件太大");
      return false;
    }
    return upload(file);
  } else if (limit_size === "no" || file.size < limit_size) {
    // 不压缩,直接上传
    return upload(file);
  } else {
    // 压缩后上传
    if (option.no_compress) {
      console.log("图片太大");
      return false;
    }
    console.log("图片大于" + formatSize(limit_size));
    let blob = await compress();
    console.log("压缩后", formatSize(blob.size));
    let size = blob.size / 1000;
    if (size > 600) {
      console.log("图片太大");
      return false;
    }
    return upload(blob);
  }
}

async function uploadImageCompress(option = {}) {
  if (process.env.NODE_ENV === "development") {
    return uploadImage(option);
  }
  let file = option.file;
  let head_name = option.head_name;
  let full_name = option.full_name;
  let fileType = option.fileType || "image";
  let forcedExt = String(option.file_ext || option.ext || "")
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
  let bx = forcedExt;
  if (!bx) {
    const rawName = (file && file.name) || "";
    bx = rawName.includes(".")
      ? String(rawName.split(".").pop() || "")
          .toLowerCase()
          .replace(/[^a-z0-9]/g, "")
      : "";
  }
  if (!bx) {
    const mime = (file && file.type) || "";
    const mimeMap = {
      "application/pdf": "pdf",
      "application/msword": "doc",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
      "application/vnd.ms-powerpoint": "ppt",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        "pptx",
      "image/jpeg": "jpg",
      "image/jpg": "jpg",
      "image/png": "png",
      "image/gif": "gif",
    };
    bx = mimeMap[mime] || "";
  }
  if (!bx) {
    const subtype = ((file && file.type) || "").split("/")[1] || "";
    bx =
      subtype && subtype.indexOf(".") < 0 && subtype.indexOf("+") < 0
        ? subtype === "jpeg"
          ? "jpg"
          : subtype
        : fileType;
  }
  let name = "." + bx;
  if (full_name) {
    name = full_name + name;
  } else {
    name = head_name + "_" + createId() + name;
  }
  let param = new FormData();
  param.append("pic", file, name);
  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  let resData;
  try {
    resData = await axios.post(
      Vue.prototype.$url_prefix + "uploadImage",
      param,
      config
    );
  } catch (err) {
    console.log("upload error", err);
  }
  console.log("resData", resData);
  if (resData && resData.data && resData.data.success) {
    return resData.data.data;
  }
  return false;
}

// 计算路径
async function planRoute(lnglat1, lnglat2) {
  let amap_driving = new AMap.Driving({
    policy: AMap.DrivingPolicy.LEAST_DISTANCE,
  });
  let amap_walking = new AMap.Walking();
  let amap_riding = new AMap.Riding();
  let amap_transfer = new AMap.Transfer({
    city: store.state.Counter.city,
  });

  function getClosestDot(a, b) {
    let lista = a.split("-");
    let listb = b.split("-");
    let dota = lista[0].split("|");
    let dotb = listb[0].split("|");
    let distance = AMap.GeometryUtil.distance(dota, dotb);
    for (let i = 0; i < lista.length; i++) {
      for (let j = 0; j < listb.length; j++) {
        let pointa = lista[i].split("|");
        let pointb = listb[j].split("|");
        let temp = AMap.GeometryUtil.distance(pointa, pointb);
        if (temp < distance) {
          distance = temp;
          dota = pointa;
          dotb = pointb;
        }
      }
    }
    return {
      a: dota,
      b: dotb,
      distance: distance,
    };
  }

  function driving(start, end) {
    return new Promise((resolve, reject) => {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        resolve("查询开车路径失败");
        console.log("driving timeout");
      }, 1000);
      amap_driving.search(start, end, function (status, result) {
        clearTimeout(timer);
        if (status === "complete") {
          // console.log('查询开车路径成功')
          let mid = [
            result.routes[0].steps[0].start_location.lng,
            result.routes[0].steps[0].start_location.lat,
          ];
          let distance = AMap.GeometryUtil.distance(start, mid);
          let time =
            distance / (result.routes[0].distance / result.routes[0].time);
          let dataObj = {
            distance: Math.round(result.routes[0].distance + distance),
            duration: Math.round(result.routes[0].time + time),
            move: "driving",
          };
          resolve(dataObj);
        } else {
          // console.log('查询开车路径失败')
          resolve("查询开车路径失败");
        }
      });
    });
  }

  function walking(start, end) {
    return new Promise((resolve, reject) => {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        resolve("查询步行路径失败");
        console.log("walking timeout");
      }, 1000);
      amap_walking.search(start, end, function (status, result) {
        clearTimeout(timer);
        if (status === "complete") {
          // console.log('查询步行路径成功')
          let mid = [
            result.routes[0].steps[0].start_location.lng,
            result.routes[0].steps[0].start_location.lat,
          ];
          let distance = AMap.GeometryUtil.distance(start, mid);
          let time =
            distance / (result.routes[0].distance / result.routes[0].time);
          let dataObj = {
            distance: Math.round(result.routes[0].distance + distance),
            duration: Math.round(result.routes[0].time + time),
            move: "walking",
          };
          resolve(dataObj);
        } else {
          // console.log('查询步行路径失败')
          resolve("查询步行路径失败");
        }
      });
    });
  }

  function riding(start, end) {
    return new Promise((resolve, reject) => {
      amap_riding.search(start, end, function (status, result) {
        if (status === "complete") {
          // console.log('查询骑行路径成功')
          let mid = [
            result.routes[0].rides[0].start_location.lng,
            result.routes[0].rides[0].start_location.lat,
          ];
          let distance = AMap.GeometryUtil.distance(start, mid);
          let time =
            distance / (result.routes[0].distance / result.routes[0].time);
          let dataObj = {
            distance: Math.round(result.routes[0].distance + distance),
            duration: Math.round(result.routes[0].time + time),
            move: "riding",
          };
          resolve(dataObj);
        } else {
          // console.log('查询骑行路径失败')
          resolve("查询骑行路径失败");
        }
      });
    });
  }
  function transfer(start, end) {
    return new Promise((resolve, reject) => {
      amap_transfer.search(start, end, function (status, result) {
        if (status === "complete" && result.info === "OK") {
          // console.log('查询公交路径成功')
          let dataObj = {
            distance: result.plans[0].distance,
            duration: result.plans[0].time,
            move: "transfer",
          };
          resolve(dataObj);
        } else {
          // console.log('查询公交路径失败')
          resolve("查询公交路径失败");
        }
      });
    });
  }

  let closest = getClosestDot(lnglat1, lnglat2);
  let location_data = {};
  let temp = await driving(closest.a, closest.b);
  if (typeof temp === "object") {
    location_data[temp.move] = {
      distance: temp.distance,
      duration: temp.duration,
    };
  }
  temp = await walking(closest.a, closest.b);
  if (typeof temp === "object") {
    location_data[temp.move] = {
      distance: temp.distance,
      duration: temp.duration,
    };
  }
  // temp = await riding(closest.a, closest.b)
  // if (typeof temp === 'object') {
  //   location_data[temp.move] = {
  //     distance: temp.distance,
  //     duration: temp.duration
  //   }
  // }
  // temp = await transfer(closest.a, closest.b)
  // if (typeof temp === 'object') {
  //   location_data[temp.move] = {
  //     distance: temp.distance,
  //     duration: temp.duration
  //   }
  // }
  return location_data;
}

function getLocationLnglat(target) {
  let loc_lnglat = target.lnglat;
  if (target.boundary && target.boundary.length > 0) {
    loc_lnglat = target.boundary.map((x) => x.join("|")).join("-");
  }
  if (target.metroExit && target.metroExit.length > 0) {
    loc_lnglat = target.metroExit.map((x) => x.lnglat).join("-");
  }
  return loc_lnglat;
}

// 读取excel内容
function readExcel(file, parseFunc) {
  parseFunc = parseFunc || XLSX.utils.sheet_to_json;
  return new Promise((resolve, reject) => {
    let fileReader = new FileReader();
    fileReader.onload = function (ev) {
      try {
        var data = ev.target.result;
        var workbook = XLSX.read(data, {
          type: "binary",
        }); // 以二进制流方式读取得到整份excel表格对象
        var rows = []; // 存储获取到的数据
      } catch (e) {
        reject("文件类型不正确");
      }
      // 表格的表格范围，可用于判断表头是否数量是否正确
      var fromTo = "";
      // 遍历每张表读取
      for (var sheet in workbook.Sheets) {
        if (workbook.Sheets.hasOwnProperty(sheet)) {
          fromTo = workbook.Sheets[sheet]["!ref"];
          console.log(fromTo);
          rows = rows.concat(parseFunc(workbook.Sheets[sheet]));
          // break; // 如果只取第一张表，就取消注释这行
        }
      }
      resolve(rows);
    };
    // 以二进制方式打开文件
    fileReader.readAsBinaryString(file);
  });
}

function drawVideoCover(url) {
  console.log("drawVideoCoverbefore", url);

  if (!Vue.prototype.$url_prefix.includes("http")) {
    if (url.includes("suzhou")) {
      url = url.replace(
        "https://xiaoji-suzhou.oss-cn-hangzhou.aliyuncs.com/",
        "/suzhou"
      );
    } else if (url.includes("tianjin")) {
      url = url.replace(
        "https://xiaoji-tianjin.oss-cn-beijing.aliyuncs.com/",
        "/tianjin"
      );
    } else if (url.includes("ningbo")) {
      url = url.replace(
        "https://xiaoji-ningbo.oss-cn-hangzhou.aliyuncs.com/",
        "/ningbo"
      );
    } else if (url.includes("shanghai")) {
      url = url.replace(
        "https://xiaoji-shanghai.oss-cn-shanghai.aliyuncs.com/",
        "/shv"
      );
    } else {
      url = url.replace(
        "https://xiaoji-hangzhou.oss-cn-hangzhou.aliyuncs.com/",
        "/hangzhou"
      );
    }
  }
  console.log("drawVideoCoverurl", url);
  return new Promise(function (resolve, reject) {
    let img = new Image();
    img.setAttribute("crossOrigin", "Anonymous");
    img.src = url;
    console.log("img", img.src);
    console.log("url", url);

    img.onload = function () {
      let canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext("2d").drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/jpeg"));
    };
  });
}

function downloadExcel(filename, data, keys, ths) {
  ths = ths || keys;
  let table = "<table>";
  let row = "<tr>";
  for (let i = 0; i < ths.length; i++) {
    row += "<th>" + ths[i] + "</th>";
  }
  table += row + "</tr>";
  for (let i = 0; i < data.length; i++) {
    let td = "<tr>";
    for (let key of keys) {
      if (filename == "置业顾问管理") {
        let m = data[i][key] || "";
        if (key == "estates")
          m =
            data[i][key].length >= 0
              ? data[i][key].map((item) => item.name).join(",")
              : "";
        td += `<td>${m}</td>`;
      } else td += `<td style="mso-number-format:'\@'">${data[i][key]||''}</td>`;
    }
    td += "</tr>";
    table += td;
  }

  let excelFile =
    "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
    "xmlns:x='urn:schemas-microsoft-com:office:excel' xmlns='http://www.w3.org/TR/REC-html40'>";
  excelFile +=
    '<meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8">';
  excelFile +=
    '<meta http-equiv="content-type" content="application/vnd.ms-excel';
  excelFile += '; charset=UTF-8">';
  excelFile += "<head>";
  excelFile += "<!--[if gte mso 9]>";
  excelFile += "<xml>";
  excelFile += "<x:ExcelWorkbook>";
  excelFile += "<x:ExcelWorksheets>";
  excelFile += "<x:ExcelWorksheet>";
  excelFile += "<x:Name>";
  excelFile += "sheet";
  excelFile += "</x:Name>";
  excelFile += "<x:WorksheetOptions>";
  excelFile += "<x:DisplayGridlines/>";
  excelFile += "</x:WorksheetOptions>";
  excelFile += "</x:ExcelWorksheet>";
  excelFile += "</x:ExcelWorksheets>";
  excelFile += "</x:ExcelWorkbook>";
  excelFile += "</xml>";
  excelFile += "<![endif]-->";
  excelFile += "</head>";
  excelFile += "<body>";
  excelFile += table;
  excelFile += "</body>";
  excelFile += "</html>";
  let uri =
    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8,base64," +
    encodeURIComponent(excelFile);
  let link = document.createElement("a");
  link.href = uri;
  let download = `${filename}.xlsx`;
  link.download = download;
  link.click();
}
// debounce.js
function debounce(func, wait) {
  let timeout;
  const debounced = function (...args) {
    const context = this;
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };

  debounced.cancel = function () {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}

Vue.prototype.$recordHistory = function recordHistory(demand_id, action) {
  // console.log(demand_id, action)
  if (demand_id && action) {
    axios
      .post(Vue.prototype.$url_prefix + "requirement/history/record", {
        demand_id,
        action,
      })
      .then((res) => {
        // console.log('历史记录',res)
      });
  }
};

Vue.prototype.$open = () => {
  Vue.prototype.$myLoading = Vue.prototype.$loading({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
};
Vue.prototype.$close = () => {
  if (Vue.prototype.$myLoading) {
    Vue.prototype.$myLoading.close();
  }
};

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.prototype.$uploadImage = uploadImage;
Vue.prototype.$uploadImageCompress = uploadImageCompress;
Vue.prototype.$planRoute = planRoute;
Vue.prototype.$getMapCenter = getMapCenter;
Vue.prototype.$SortFun = SortFun;
Vue.prototype.$getLocationLnglat = getLocationLnglat;
Vue.prototype.$drawVideoCover = drawVideoCover;
Vue.prototype.$debounce = debounce;
Vue.prototype.$readExcel = readExcel;
Vue.prototype.$downloadExcel = downloadExcel;
const server_port = process.env.SERVER_PORT;
const shanghai_port = process.env.SHANGHAI_PORT;
const travel_port = process.env.TRAVEL_PORT;
const xiaoqu_port = process.env.XIAOQU_PORT;
const zuwo_port = process.env.ZUWO_PORT;
if (process.env.NODE_ENV === "development") {
  Vue.prototype.$url_prefix = "/erp/";
  Vue.prototype.$url_prefix4 = "/travel/";
  Vue.prototype.$url_prefix5 = "/xiaoqu/";
  Vue.prototype.$url_prefix2 = "/shanghai/";
  Vue.prototype.$url_prefix3 = "/xcx/";
  Vue.prototype.$zhke_url = "/xiaojizuke/";
  Vue.prototype.$zuwo_url = "/zuwo/";
  // Vue.prototype.$zhke_url = 'https://www.xaoji.com/xiaojizuke/';
} else {
  Vue.prototype.$url_prefix = `https://www.xaoji.com:${server_port}/erp/`;
  Vue.prototype.$url_prefix2 = `https://www.xaoji.com:${shanghai_port}/erp/`;
  Vue.prototype.$url_prefix3 = `https://www.xaoji.com:${server_port}/api/`;
  Vue.prototype.$url_prefix4 = `https://www.xaoji.com:${travel_port}/`;
  Vue.prototype.$url_prefix5 = `https://www.xaoji.com:${xiaoqu_port}/api/`;
  Vue.prototype.$zuwo_url = `https://www.xaoji.com:${zuwo_port}/erp/`;
  Vue.prototype.$zhke_url = "https://www.xaoji.com/xiaojizuke/";
}
Vue.prototype.$device_auth_url_prefix =
  window.location.protocol === "https:" &&
  ["admin.xaoji.com", "admin-test.xaoji.com"].includes(
    window.location.hostname,
  )
    ? "/erp/"
    : Vue.prototype.$url_prefix;
Vue.prototype.$base_url = `https://www.xaoji.com:${server_port}/`;

// 自定义指令：自动获取焦点
Vue.directive("focus", {
  inserted: function (el) {
    el.focus();
    el.select();
  },
});


// 添加当前城市的URL前缀
Vue.prototype.$currentUrlPrefix = store.state.Counter.city === '上海' ? Vue.prototype.$url_prefix2 : Vue.prototype.$url_prefix;

// 监听城市变化，更新全局变量
store.watch(
  (state) => state.Counter.city,
  (newCity) => {
    Vue.prototype.$currentUrlPrefix = newCity === '上海' ? Vue.prototype.$url_prefix2 : Vue.prototype.$url_prefix;
  }
);

// 添加事件总线
Vue.prototype.$bus = new Vue();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  components: {
    App,
  },
  router,
  store,
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js